<div class="visualisation-tool-panel-container">
  <div class="form-container fx-layout-col fx-justify-space-evenly fx-align-center">
    <form [formGroup]="visualisationForm" novalidate class="fx-layout-col fx-justify-space-evenly fx-align-center" autocomplete="off">
      <div class="field-label fx-flex-100-33-percent">
        {{ 'LABEL.APPLIED_VISUALISATION' | translate }}
      </div>
      <div class="field-container fx-flex-100-66-percent fx-layout-col">
        <mat-form-field appearance="outline">
          <mat-select formControlName="currentVisualisation"
                      [compareWith]="compareById"
                      id="input-current-visualisation"
                      required>
            @for (datagridVisualisation of (visualisations$ | async); track datagridVisualisation.id) {
              <mat-option [value]="datagridVisualisation"
                          [matTooltip]="'TOOLTIP.SHARED_VISUALISATION' | translate"
                          [matTooltipDisabled]="!datagridVisualisation.isShared || datagridVisualisation.isDefault"
                          matTooltipPosition="right">
                {{ datagridVisualisation.name }}
              </mat-option>
            }
          </mat-select>
          @if (visualisationForm.controls.currentVisualisation.hasError('required')) {
            <mat-error>
              {{ 'ERROR.FIELD_REQUIRED' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </form>
    @if (canManageSharedVisualisations) {
      <mat-slide-toggle [id]="'visualisation-shared-toggle'" class="shared-toggle"
                        [checked]="visualisationForm.controls.currentVisualisation.value?.isShared"
                        [disabled]="!canToggleCurrentVisualisationShared"
                        [matTooltip]="(visualisationForm.controls.currentVisualisation.value?.isDefault ? 'TOOLTIP.DEFAULT_VISUALISATION_SHARED' : visualisationForm.controls.currentVisualisation.value?.isShared ? 'TOOLTIP.UNSHARE_VISUALISATION' : 'TOOLTIP.SHARE_VISUALISATION') | translate"
                        [disabledInteractive]="true"
                        (change)="onSharedToggled($event)">
        {{ 'LABEL.SHARED' | translate }}
      </mat-slide-toggle>
    }
    @if (gridStateService.gridStateModified) {
      <div [id]="'visualisation_changed_label'">
        {{ 'LABEL.VISUALISATION_CHANGED' | translate }}
      </div>
    }
    @if (canEditCurrentVisualisation) {
      <div
        class="fx-layout-col fx-justify-space-evenly fx-align-center fx-gap-10">
        @if (gridStateService.gridStateModified) {
          <button
            (click)="updateVisualisation()"
            [id]="'visualisation-update-button'"
            color="accent"
            mat-raised-button>
            {{ 'BUTTON.UPDATE_VISUALISATION' | translate }}
          </button>
        }
        <button (click)="deleteVisualisation()" [id]="'visualisation-delete-button'" mat-stroked-button>
          {{ 'BUTTON.DELETE_VISUALISATION' | translate }}
        </button>
      </div>
    }
  </div>
  <div class="button-container fx-layout-col fx-justify-space-evenly fx-align-center fx-gap-10">
    <button (click)="createVisualisation()" [id]="'visualisation-create-button'"
            [matTooltip]="'TOOLTIP.SAVE_VISUALISATION' | translate"
            mat-stroked-button>
      {{ 'BUTTON.SAVE_VISUALISATION' | translate }}
    </button>
  </div>
</div>
